import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import CustomChip from '../../../Components/CustomChip';
import { CustomButton } from '../../../../v2/MUI_custom_component';
import CardHeader from '../../Common/CardHeader';
import { cardStyles, PROFILER_IMAGES } from '../../Common/constants';
import { ProfilerQuestionID } from '../../config/QuestionEnum';
import { getQuestionConfig } from '../../config/questionsConfig';


const questionConfig = getQuestionConfig(ProfilerQuestionID.PREFERRED_HOLIDAY_DESTINATION);
const OPTIONS = questionConfig?.options?.map(opt => opt.label) || [];

const RecreationalType = ({
    questionId = ProfilerQuestionID.PREFERRED_HOLIDAY_DESTINATION,
    title = questionConfig?.question || 'Where would you like to go for holiday in India?',
    value,
  defaultValue = '',
    onChange,
    onSubmit,
    submitLabel = 'Submit',
    width='300px',
    maxWidth='300px',
}) => {
  const isControlled = typeof value === 'string';
  const [internalValue, setInternalValue] = useState(defaultValue);
  const selectedValue = isControlled ? value : internalValue;

  const handleToggle = (option) => {
    const updated = selectedValue === option ? '' : option;
    if (!isControlled) setInternalValue(updated);
    onChange?.(updated);
  };

  const handleSubmit = () => {
    onSubmit?.({
      question: [
        { id: questionId, value: selectedValue }
      ]
    });
  };

  return (
    <Box sx={cardStyles({ width, maxWidth })}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, flex: 1, justifyContent: 'space-between' }}>
        <CardHeader title={title} />
        <Box component='img' alt='Recreational Domestic' width={'100%'} src={PROFILER_IMAGES.holiday_preference} />
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'center',}}>
          {OPTIONS.map(option => (
            <CustomChip
              key={option}
              label={option}
              selected={selectedValue === option}
              onClick={() => handleToggle(option)}
              
            />
          ))}
        </Box>
        <CustomButton
          label={submitLabel}
          onClick={handleSubmit}
          disabled={!selectedValue}
          size='small'
          sx={{ width: '100%' }}
        />
      </Box>
    </Box>
  );
};

export default RecreationalType;
